<template>
	<div class="linkto d-flex align-items-center">
		<span class="h6 float-left">
			<button class="btn btn-danger" @click.prevent="goback">
				<i class="fas fa-chevron-left fa-lg d-none d-md-block">
	        		Vissza
	        	</i>
	        	<i class="fas fa-chevron-left fa-lg d-md-none">
	        	</i>
			</button>
	    </span>
	</div>
</template>
<script>
export default {
	name: 'linkto',

	props: ['link'],
	
	methods: {
		goback(){
			if(window.history.length === 1) {
				window.close()
			} else {
				this.$router.go(-1)	
			}
		}
	}
}
</script>
<style scope>
.linkto {
	left: 10px;
	top: 10px;
	height: 80%;
	position: absolute;
}
</style>


// WEBPACK FOOTER //
// src/components/link_to.vue